import { VISION_ID } from 'core/constants/products'
import updateAddons from 'sites/pivothealth.com/fixed-benefit-medical/consumer/quotes/utils/updateAddons'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
import handleAddons from '../controller/handleAddons'

function handleToggleVision(): void {
  const addonId = +this.getAttribute('data-id')
  const planId = this.getAttribute('data-planId')
  const visionInput = getById(`vision-${planId}-addon-${addonId}`)
  const deleteVision = visionInput && !visionInput.checked

  const state = store.getState()

  const { addonsByPlan, latitudeAddons, dentalAddons, visionAddons } = state

  const latitudePlan = latitudeAddons[planId]
  const dentalPlan = dentalAddons[planId]
  const visionPlan = visionAddons[planId]

  let planAddons = addonsByPlan[planId] || []

  if (dentalPlan === addonId) {
    planAddons = [latitudePlan, dentalPlan].filter(Boolean)
    if (!deleteVision) {
      planAddons.push(VISION_ID)
    }
  } else {
    planAddons = [latitudePlan, dentalPlan, visionPlan].filter(Boolean)
  }

  this.dataset.spValue = deleteVision ? 'add vision' : 'remove vision'

  addonsByPlan[planId] = planAddons
  const newState = { ...state, addonsByPlan }
  updateAddons(newState)
  handleAddons({ ...state, addonsByPlan }, planId)
}
export default handleToggleVision
